<template>
  <v-btn class="secondary" @click="confirmAbandon" outlined>
    <i class="fa-regular fa-running"></i>
    {{ $t("btnText") }}
    <v-snackbar color="#C42A14" v-model="showMsg">
      {{ $t("errorAbandoned") }}
    </v-snackbar>
  </v-btn>
</template>

<script>
export default {
  name: "AbandonButton",
  data() {
    return {
      canLeft: false,
      daysLeft: -1,
      showMsg: false
    };
  },
  mounted() {
    this.calculateDaysToAbandon();
  },
  methods: {
    calculateDaysToAbandon() {
      let abandonTime = new Date(this.$store.state.fundingTest.createdAt);
      abandonTime.setDate(abandonTime.getDate() + 3);
      let differenceInTimeTotal = abandonTime.getTime() - new Date().getTime();
      this.daysLeft = Math.floor(differenceInTimeTotal / (1000 * 3600 * 24));
      this.canLeft = this.daysLeft < 0;
    },
    confirmAbandon() {
      if (this.canLeft) this.$emit("confirmAbandon");
      else {
        this.showMsg = true;
      }
    },
  },
};
</script>



<style lang="scss" scoped>
@import "src/global";

.abandon-button {
  .fa-running {
    margin-right: 10px;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 38px;
    margin-top: 30px;
    padding: unset;
    font-size: 12px;
  }

  background: var(--v-cardHeaderBackground-base);
  border: 1px solid transparent;
  outline: 0;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>
